import { render, staticRenderFns } from "./GeneralTests.vue?vue&type=template&id=ed860de0&scoped=true&"
import script from "./GeneralTests.vue?vue&type=script&lang=js&"
export * from "./GeneralTests.vue?vue&type=script&lang=js&"
import style0 from "./GeneralTests.vue?vue&type=style&index=0&id=ed860de0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed860de0",
  null
  
)

component.options.__file = "GeneralTests.vue"
export default component.exports